import React from 'react';

import './navItem.css'

function NavItem(props){
    return (
        <div className="nav--item--container">
            
            {props.children}
            <div className="item--underline">

            </div>
        </div> 
      );
}


export default NavItem;